/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { v4 as uuidv4 } from "uuid";
import config from "../config/kanbanList.config.json";

export interface IKanbaListMethods extends IPluginMethodMap {
  getKanbanList(args: any): Promise<any>;
  getKanbanProps(args: any): Promise<any>;
  updateKanbanList(args: any): Promise<any>;
}

export class KanbanListService implements IAgentPlugin {
  readonly methods: IKanbaListMethods;
  private list: any[] = config.kanbanList;
  constructor() {
    this.methods = {
      getKanbanList: this.getList.bind(this),
      getKanbanProps: this.getProps.bind(this),
      updateKanbanList: this.updateList.bind(this),
    };
    this.list[0].id = uuidv4();
  }

  async getProps(args: any) {
    return {
      ...(config || {}),
      kanbanList: this.list,
    };
  }

  async updateList(args: any) {
    if (args) {
      this.list = args;
    }
  }

  async getList(args: any) {
    return {
      kanbanList: this.list,
    };
  }
}
